import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface GetRoomTokenResponse {
  roomToken: string;
}

interface GetRoomTokenParams {
  patientId: string;
  encounterId?: string;
}

export const useRoomToken = ({
  patientId,
  encounterId,
}: GetRoomTokenParams) => {
  return useApi<GetRoomTokenResponse, string>({
    queryOptions: {
      queryKey: QueryKeys.Patient.RoomToken.DEFAULT(patientId, encounterId),
      queryFn: async () => {
        const response = await axiosInstance.get("new-api/chat/room-token", {
          params: { patientId, encounterId },
        });
        return response.data;
      },
      enabled: Boolean(patientId),
      select: (data) => data.roomToken,
    },
  });
};
